import { useState, FC } from 'react'

import { orientation } from '@/constants/focus'
import { icons } from '@/constants/icons'

import { keyboardConfigs, COLUMNS_COUNT } from './constants'
import { Grid, GridItem, Wrapper } from './Keyboard.styles'
import { KeyboardAsideActionBar } from './KeyboardAsideActionBar'
import { KeyboardFooterActionBar } from './KeyboardFooterActionBar'
import { KeyboardLayout } from './KeyboardLayout'
import { KeyboardType, KeyboardProps } from './types'

export const Keyboard: FC<KeyboardProps> = ({
  onSelect,
  bottomPanelButtonsConfig = [],
  rightPanelButtonsConfig = [],
  focusIdPrefix,
}) => {
  const [keyboardType, setKeyboardType] = useState(KeyboardType.ABCDEF)
  const [keyboardPosition, setKeyboardPosition] = useState({
    row: 1,
    col: 0,
  })
  const config = keyboardConfigs[keyboardType]

  const getNewKeyboardType = (prev: KeyboardType) =>
    prev === KeyboardType.QWERTY ? KeyboardType.ABCDEF : KeyboardType.QWERTY

  const bottomButtons = [
    {
      text: 'Space',
      onClick: () => handleSelect('Space'),
    },
    ...bottomPanelButtonsConfig,
    {
      icon: icons.keyboard.clear,
      onClick: () => handleSelect('Backspace'),
    },
  ]

  const buttonsSidebar = [
    ...rightPanelButtonsConfig,
    {
      text: getNewKeyboardType(keyboardType).substring(0, 3),
      onClick: () => {
        setKeyboardType(getNewKeyboardType)
        setTimeout(() => {
          setKeyboardPosition({
            col: COLUMNS_COUNT - 1,
            row: rightPanelButtonsConfig.length + 1,
          })
        }, 0)
      },
    },
  ]
  const hideKeyboardAsideActionBar = true

  const handleSelect = (key: string) => {
    onSelect?.(key)
  }

  const onAsideActionBarMove = ({ nextChildIndex }: MoveEvent) => {
    setKeyboardPosition((prev) => ({ ...prev, row: nextChildIndex }))
  }

  return (
    <Wrapper orientation={orientation.VERTICAL}>
      <Grid>
        <GridItem>
          <KeyboardLayout
            config={config}
            onSelect={handleSelect}
            type={keyboardType}
            onGridMove={setKeyboardPosition}
            defaultFocusRow={keyboardPosition.row}
            defaultFocusColumn={keyboardPosition.col}
            focusIdPrefix={focusIdPrefix}
          />
        </GridItem>
        {!hideKeyboardAsideActionBar && (
          <GridItem>
            <KeyboardAsideActionBar
              config={buttonsSidebar}
              onMove={onAsideActionBarMove}
              defaultFocusChild={keyboardPosition.row}
            />
          </GridItem>
        )}
      </Grid>
      <KeyboardFooterActionBar
        config={bottomButtons}
        focusIdPrefix={focusIdPrefix}
      />
    </Wrapper>
  )
}
